/**
 * Rollen en rechten aan de frontendkant.
 *
 * Hier staat géén tweede kopie van de rechtenmatrix. Die matrix heeft één bron —
 * `RECHTEN` in [`api/src/rollen.ts`](../../api/src/rollen.ts) — en komt via
 * `GET /api/me` mee, zowel als de vlaggen van de ingelogde gebruiker (`rechten`) als
 * de volledige matrix voor het beheerscherm (`matrix`). Dit bestand bevat alleen de
 * types en de leesbare labels.
 *
 * Verbergen in de frontend is nooit de grens: de API weigert dezelfde handelingen.
 */
export type RolSleutel = 'admin' | 'productievoorbereiding' | 'tekenaar' | 'productiemedewerker';

export const ROLLABEL: Record<RolSleutel, string> = {
  admin: 'Admin',
  productievoorbereiding: 'Productievoorbereiding',
  tekenaar: 'Tekenaar',
  productiemedewerker: 'Productie',
};

/** Wat een rol in één regel mag; voor de uitleg in het beheerscherm. */
export const ROLUITLEG: Record<RolSleutel, string> = {
  admin: 'Alles, inclusief normtijden en beheer.',
  productievoorbereiding:
    'Houtstaat, werkvloer, dashboard, planning, foutmeldingen en het splitsen in karren.',
  tekenaar:
    'Alleen data inladen en foutcontroles bekijken. Geen stappen aanpassen, geen werkvloer, geen dashboard, geen beheer.',
  productiemedewerker:
    'Alleen de werkvloer. Geen foutmeldingen, geen uren of normtijden, geen dashboard.',
};

/** De leesbare naam van een recht, voor de matrix in het beheerscherm. */
export const RECHTLABEL: Record<string, string> = {
  houtstaatBekijken: 'Houtstaat bekijken',
  werkvloerBekijken: 'Werkvloer bekijken',
  dashboardBekijken: 'Dashboard bekijken',
  planningBekijken: 'Planning bekijken',
  regelsBekijken: 'Bewerkingen en berekeningen bekijken',
  modelBekijken: '3D-model bekijken',
  beheerBekijken: 'Beheer bekijken',
  foutmeldingenZien: 'Foutmeldingen zien',
  rodeWaardenGoedkeuren: 'Afwijkingen goedkeuren',
  urenZien: 'Uren en normtijden zien',
  normtijdenBewerken: 'Normtijden wijzigen',
  gegevensAanpassen: 'Gegevens inline aanpassen',
  dataInladen: 'Data inladen (TopSolid en Excel)',
  karrenSplitsen: 'Bouwelement splitsen in karren',
  modelBeheren: "STL's inladen",
  exporteren: 'Exporteren naar PDF en CSV',
  takenAfstrepen: 'Stappen afstrepen',
  reworkStarten: 'Rework melden',
  stapOpmerken: 'Opmerking bij een stap',
  stapInstellen: 'Stapinstellingen (fotoplicht)',
  volgordeOpenStappen: 'Volgorde van open stappen',
  volgordeAfgevinkteStappen: 'Volgorde van afgestreepte stappen',
  producerenVrijgeven: 'Vrijgeven voor productie',
  onHoldZetten: 'On-hold zetten',
  planningWijzigen: 'Planning wijzigen',
  coderingenBewerken: 'Coderingen bewerken',
  regelsBewerken: 'Bewerkingen en berekeningen opslaan',
  gebruikersbeheer: 'Gebruikersbeheer',
};
